export default __webpack_public_path__ + "static/DSC_0022-7f4a8ae2145c113e841f73d1a5877295.jpg";